import { useEffect, useState } from "react";
import { InterviewService } from "../../../../services/InterviewService";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export function Managers() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  const [managers, setManagers] = useState([]);

  useEffect(() => {
    InterviewService.GetManagerList().then((data) => setManagers(data));
  }, []);

  return (
    <fieldset>
      <legend>{t("Manager")}</legend>
      <select
        className="form-select"
        name="managerId"
        onChange={onChange}
        value={searchObject.managerId || ""}
      >
        <option value=""></option>
        {managers.map((managers) => (
          <option key={managers.id} value={managers.id}>
            {managers.nickname}
          </option>
        ))}
      </select>
    </fieldset>
  );
}
